import React from "react";
import {
    Autocomplete,
    Checkbox,
    TextField,
    Chip,
    Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { Helmet } from 'react-helmet'
import { Formik } from "formik";
import { Loadable } from "../../../common";
import { Grid, Switch, FormControlLabel, Button } from "@mui/material";
import { useData } from "@pure-ptr/react";
import {
    Portlet,
    PortletBody,
    PortletHeader,
    PortletHeaderToolbar,
} from "../../../partials/content/Portlet";
import {
    getNotificationCategories,
    getNotificationSubscriptions,
    createNotificationSubscription,
    getNotificationChannels,
} from "../../../store/api/notificationsSubscriptions";
import {selectClientListTiny as selectAllClientListTiny } from "../../../store/selectors/clients";
import { useSelector } from "react-redux";
import { getClientsTiny } from "../../../store/api/clients";
import { errorToastify } from "../../../util/toast";
import { ToastMessage } from "../../../common";
import { selectSessionRole } from "../../../store/selectors/session";
import { ROLE_USER, ROLE_ADMIN } from "../../../store/constants/roles";



export default function NotificatiosSubscriptionsManagementPage() {
    const [subscriptionPayload, setSubscriptionPayload] = useState({});
    const clients = useSelector(selectAllClientListTiny);
    const sessionRole = useSelector(selectSessionRole);
    const isUserOrAdmin = sessionRole === ROLE_USER || sessionRole === ROLE_ADMIN;

    const { data: subscriptions, isPending: isFetchingSubcriptions,error:fetchingSubscriptionsError } =
        useData(async () => {
            const subscriptions = await getNotificationSubscriptions();
            return subscriptions;
        }, []);

    const {
        data,
        isPending: isFetchingAllCategories,
        error:fetchingDropdownOptions,
    } = useData(async () => {
        await getClientsTiny();
        const channels = await getNotificationChannels();
        const categories = await getNotificationCategories();
        return { categories, channels };
    }, []);

    const { isPending: isCreatingSubscription, error: subscriptionError } =
        useData(async () => {
            if (Object.keys(subscriptionPayload).length == 0) return;
            const categories = await createNotificationSubscription(
                subscriptionPayload
            );
            setSubscriptionPayload({});
            return categories;
        }, [subscriptionPayload]);

    const [formValues, setFormValues] = useState({
        eventType: [],
        notificationType: [],
        clientIds: [],
        active: false,
    });


    
    useEffect(() => {
        if (isFetchingAllCategories != null) return;
        
        let mappedClients = [];
        let mappedChannels = [];
        let mappedCategories = [];
        let active = false;
        let shouldUpdate = false;

        if (
            subscriptions &&
            subscriptions.channels &&
            subscriptions.channels.length > 0
        ) {
            mappedClients =
                clients?.filter((c) =>
                    subscriptions.clientIds?.some((id) => id == c.clientId)
                ) || [];
            mappedChannels =
                data?.channels?.filter((c) =>
                    subscriptions.channels?.includes(c.code)
                ) || [];
            mappedCategories =
                data?.categories?.filter((c) =>
                    subscriptions.categories?.includes(c.code)
                ) || [];
            
            active = subscriptions.activate || false;
            shouldUpdate = true;
        }

        if (isUserOrAdmin && clients?.length > 0) {
            if (mappedClients.length === 0) {
                mappedClients = [clients[0]];
                shouldUpdate = true;
            }
        }

        if (shouldUpdate) {
             setFormValues({
                clientIds: mappedClients,
                notificationType: mappedChannels,
                eventType: mappedCategories,
                active: active,
            });
        }
    }, [subscriptions, clients, data, isUserOrAdmin]);


const generateError = (triggeredError) => {
    errorToastify(
        <ToastMessage
            errorMessage={triggeredError?.payload?.error}
            innerException={triggeredError?.payload?.innerException}
            errorDetails={triggeredError?.payload?.errorDetails}
        />
    );
};

useEffect(() => {
    if (
        !subscriptionError &&
        !fetchingDropdownOptions &&
        !fetchingSubscriptionsError
    )
        return;

    generateError(
        fetchingSubscriptionsError ||
            fetchingDropdownOptions ||
            subscriptionError
    );
}, [subscriptionError]);

    return (
        <Loadable
            loading={
                isCreatingSubscription != null ||
                isFetchingAllCategories != null ||
                isFetchingSubcriptions != null
            }
        >
            <Helmet title="Notification Subscription Settings" />
            <Formik
                enableReinitialize={true}
                initialValues={formValues}
                validate={(values) => {
                    const errors: any = {};

                    if (!values.clientIds?.length)
                        errors.clientIds = "Required";
                    if (!values.eventType?.length)
                        errors.eventType = "Required";
                    if (!values.notificationType?.length)
                        errors.notificationType = "Required";

                    return errors;
                }}
                onSubmit={async (values) => {
                    const payload = {
                        clientIds:
                            values.clientIds?.map((c) => c?.clientId) || [],
                        channels:
                            values.notificationType?.map((t) => t.code) || [],
                        categories: values.eventType?.map((e) => e.code) || [],
                        activate: values.active,
                    };

                    setSubscriptionPayload({ ...payload });
                }}
            >
                {({ values, setFieldValue, errors, touched, handleSubmit }) => (
                    <form onSubmit={handleSubmit}>
                        <Portlet>
                            <PortletHeader
                                toolbar={
                                    <PortletHeaderToolbar className="w-100">
                                        <Grid container justifyContent="end">
                                            <Button
                                                type="submit"
                                                variant="contained"
                                                color="primary"
                                                className="ml-3"
                                            >
                                                Save
                                            </Button>
                                        </Grid>
                                    </PortletHeaderToolbar>
                                }
                            />

                            <PortletBody>
                                <Grid container spacing={3}>
                                    {/* Notification Type */}
                                    <Grid item xs={12}>
                                        <MultiSelectWithCheckbox
                                            label="Notification Type *"
                                            errors={errors}
                                            touched={touched}
                                            value={values.notificationType}
                                            options={[
                                                {
                                                    id: -1,
                                                    name: "Select All",
                                                    label: "Select All",
                                                },
                                                ...(data?.channels || []),
                                            ]}
                                            onChange={(val) =>
                                                setFieldValue(
                                                    "notificationType",
                                                    val
                                                )
                                            }
                                            name="notificationType"
                                        />
                                    </Grid>

                                    {/* Event Type */}
                                    <Grid item xs={12}>
                                        <MultiSelectWithCheckbox
                                            errors={errors}
                                            touched={touched}
                                            label="Event Type *"
                                            value={values.eventType}
                                            options={[
                                                {
                                                    id: -1,
                                                    name: "Select All",
                                                    label: "Select All",
                                                },
                                                ...(data?.categories || []),
                                            ]} // Updated options
                                            onChange={(val) =>
                                                setFieldValue("eventType", val)
                                            }
                                            name="eventType"
                                        />
                                    </Grid>

                                    {/* Clients */}
                                    <Grid item xs={12}>
                                        {isUserOrAdmin ? (
                                            <TextField
                                                label="Clients"
                                                value={values.clientIds?.[0]?.name || ""}
                                                InputProps={{
                                                    readOnly: true,
                                                }}
                                                sx={{ width: "400px" }}
                                                variant="standard"
                                                fullWidth
                                                disabled
                                            />
                                        ) : (
                                            <MultiSelectWithCheckbox
                                                errors={errors}
                                                touched={touched}
                                                label="Clients *"
                                                value={values.clientIds}
                                                options={[
                                                    {
                                                        id: -1,
                                                        name: "Select All",
                                                        label: "Select All",
                                                    },
                                                    ...(clients || []),
                                                ]}
                                                getLabel={(opt) => opt.name}
                                                onChange={(val) =>
                                                    setFieldValue("clientIds", val)
                                                }
                                                name="clientIds"
                                            />
                                        )}
                                    </Grid>

                                    {/* Active */}
                                    <Grid item xs={12}>
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={values.active}
                                                    onChange={(e) =>
                                                        setFieldValue(
                                                            "active",
                                                            e.target.checked
                                                        )
                                                    }
                                                />
                                            }
                                            label="Active"
                                        />
                                    </Grid>
                                </Grid>
                            </PortletBody>
                        </Portlet>
                    </form>
                )}
            </Formik>
        </Loadable>
    );
}

function MultiSelectWithCheckbox({
    label,
    value,
    options,
    onChange,
    name,
    touched,
    errors,
    getLabel = (opt) => opt.label,
    selectAllLabel = "Select All",
}) {
    const selectAllOption = options[0]?.id === -1 ? options[0] : null;
    const [isSliced, setIsSliced] = useState(true);

    const handleChange = (_, selected) => {
        // If "Select All" is selected
        if (selectAllOption && selected.some((x) => x.id === -1)) {
            const isAllSelected = value.length === options.length - 1;

            if (isAllSelected) {
                // unselect all
                onChange([]);
            } else {
                // select all except "Select All" item
                onChange(options.filter((x) => x.id !== -1));
            }
            return;
        }

        onChange(selected);
    };

    return (
        <Autocomplete
            multiple
            sx={{ width: "400px" }}
            disableCloseOnSelect
            value={value}
            onChange={handleChange}
            options={options}
            isOptionEqualToValue={(option, value) => {
                const getVal = (opt) => opt.id ?? opt.code ?? opt.clientId;
                return getVal(option) === getVal(value);
            }}
            getOptionLabel={getLabel}
            renderOption={(props, option, { selected }) => (
                <li {...props}>
                    <Checkbox
                        checked={selected}
                        sx={{
                            visibility:
                                option?.label === "Select All" || option?.name === "Select All"
                                    ? "hidden"
                                    : "visible",
                        }}
                    />
                    {getLabel(option)}
                </li>
            )}
            renderTags={(tagValue, getTagProps) => {
                const numTags = tagValue.length;
                return (
                    <Typography variant="caption">
                        {(isSliced ? tagValue.slice(0, 2) : tagValue).map(
                            (option, index) => (
                                <Chip
                                    {...getTagProps({ index })}
                                    key={index}
                                    label={getLabel(option)}
                                    size="small"
                                    color="secondary"
                                />
                            )
                        )}
                        {numTags > 2 && (
                            <Chip
                                size="small"
                                sx={{
                                    cursor: "pointer",
                                }}
                                onClick={() => setIsSliced(!isSliced)}
                                label={
                                    isSliced
                                        ? ` + ${numTags - 2}`
                                        : "See Less"
                                }
                            />
                        )}
                    </Typography>
                );
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={label}
                    error={Boolean(touched[name] && errors[name])}
                    helperText={touched[name] && errors[name]}
                />
            )}
        />
    );
}
